/**
 * @generated SignedSource<<1a16a5d35d8c891bec9c9c74f38e678b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "round",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shotgun",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useMarkerCodes",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Player",
  "kind": "LinkedField",
  "name": "player",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v3/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = [
  (v6/*: any*/),
  (v3/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasScores",
  "storageKey": null
},
v12 = [
  (v7/*: any*/),
  (v3/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Player",
  "kind": "LinkedField",
  "name": "playerA",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Player",
  "kind": "LinkedField",
  "name": "playerB",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "isActive",
    "value": true
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TournamentRoundsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Tournament",
        "kind": "LinkedField",
        "name": "tournament",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TournamentRound",
            "kind": "LinkedField",
            "name": "tournamentRounds",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TournamentRound_tournamentRound"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TournamentRoundsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Tournament",
        "kind": "LinkedField",
        "name": "tournament",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TournamentRound",
            "kind": "LinkedField",
            "name": "tournamentRounds",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hideFlights",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionMatchup",
                "kind": "LinkedField",
                "name": "competitionMatchups",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompetitionPlayer",
                    "kind": "LinkedField",
                    "name": "competitionPlayers",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Matchplay",
                    "kind": "LinkedField",
                    "name": "matchplays",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CourseLayout",
                "kind": "LinkedField",
                "name": "courseLayout",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "holesCount",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Flight",
                "kind": "LinkedField",
                "name": "flights",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": "flightScores",
                    "args": null,
                    "concreteType": "FlightScore",
                    "kind": "LinkedField",
                    "name": "activeFlightScores",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pairId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "playerId",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Pair",
                        "kind": "LinkedField",
                        "name": "pair",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPairsPlus",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MatchplayPlayer",
                        "kind": "LinkedField",
                        "name": "matchplayPlayer",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Matchplay",
                            "kind": "LinkedField",
                            "name": "matchplay",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "matchplayType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "teamplay",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "position",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TournamentPlayer",
                        "kind": "LinkedField",
                        "name": "tournamentPlayer",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Player",
                            "kind": "LinkedField",
                            "name": "player",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TournamentRound",
                    "kind": "LinkedField",
                    "name": "tournamentRound",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CourseLayout",
                        "kind": "LinkedField",
                        "name": "courseLayout",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Hole",
                            "kind": "LinkedField",
                            "name": "holes",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "number",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "markerCode",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startingHole",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Tournament",
                    "kind": "LinkedField",
                    "name": "tournament",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Matchplay",
                "kind": "LinkedField",
                "name": "matchplays",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MatchplayPlayer",
                    "kind": "LinkedField",
                    "name": "matchplayPlayers",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v9/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Tournament",
                "kind": "LinkedField",
                "name": "tournament",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPairs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "Pair",
                    "kind": "LinkedField",
                    "name": "pairs",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": "pairs(isActive:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamplayConfiguration",
                    "kind": "LinkedField",
                    "name": "teamplayConfiguration",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "colorA",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "colorB",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "TournamentPlayer",
                    "kind": "LinkedField",
                    "name": "tournamentPlayers",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rounds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "player",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "tournamentId",
                                "variableName": "id"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "tournamentReservationInfo",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "score",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tournamentId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": "tournamentPlayers(isActive:true)"
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailHistory",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ad71950759020b0b65f566f94a8dbdb7",
    "id": null,
    "metadata": {},
    "name": "TournamentRoundsQuery",
    "operationKind": "query",
    "text": "query TournamentRoundsQuery(\n  $id: ID!\n) {\n  tournament(id: $id) {\n    tournamentRounds {\n      round\n      ...TournamentRound_tournamentRound\n      id\n    }\n    id\n  }\n}\n\nfragment EmailFlightInfo_tournamentRound on TournamentRound {\n  emailHistory\n  id\n}\n\nfragment Flight_flight on Flight {\n  ...StatusDropdown_flight\n  code\n  databaseId\n  hasScores\n  id\n  markerCode\n  name\n  startingHole\n  startDate\n  flightScores: activeFlightScores {\n    databaseId\n    hasScores\n    pair {\n      databaseId\n      isPairsPlus\n      playerA {\n        name\n        id\n      }\n      playerB {\n        name\n        id\n      }\n      id\n    }\n    matchplayPlayer {\n      matchplay {\n        databaseId\n        matchplayType\n        teamplay\n        id\n      }\n      position\n      id\n    }\n    tournamentPlayer {\n      category\n      player {\n        databaseId\n        name\n        id\n      }\n      id\n    }\n    id\n  }\n  tournament {\n    databaseId\n    id\n  }\n  tournamentRound {\n    useMarkerCodes\n    shotgun\n    courseLayout {\n      holes {\n        number\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment Flights_flights on Flight {\n  ...Flight_flight\n  databaseId\n  startDate\n  startingHole\n}\n\nfragment Matchplay_matchplay on Matchplay {\n  databaseId\n  matchplayPlayers {\n    databaseId\n    player {\n      category\n      databaseId\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment Pair_pair on Pair {\n  databaseId\n  playerA {\n    name\n    id\n  }\n  playerB {\n    name\n    id\n  }\n}\n\nfragment Pairs_tournamentRound on TournamentRound {\n  flights {\n    flightScores: activeFlightScores {\n      pairId\n      id\n    }\n    id\n  }\n  tournament {\n    pairs(isActive: true) {\n      ...Pair_pair\n      databaseId\n      playerA {\n        name\n        id\n      }\n      playerB {\n        name\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment Player_tournamentPlayer on TournamentPlayer {\n  category\n  score\n  tournamentId\n  player {\n    databaseId\n    tournamentReservationInfo(tournamentId: $id)\n    name\n    id\n  }\n}\n\nfragment Players_tournamentRound on TournamentRound {\n  round\n  competitionMatchups {\n    databaseId\n    competitionPlayers {\n      player {\n        databaseId\n        name\n        id\n      }\n      id\n    }\n    matchplays {\n      databaseId\n      id\n    }\n    ...TournamentRoundMatchup_competitionMatchup\n    id\n  }\n  flights {\n    flightScores: activeFlightScores {\n      playerId\n      id\n    }\n    id\n  }\n  matchplays {\n    databaseId\n    matchplayPlayers {\n      player {\n        databaseId\n        name\n        id\n      }\n      id\n    }\n    ...Matchplay_matchplay\n    id\n  }\n  tournament {\n    tournamentPlayers(isActive: true) {\n      category\n      score\n      rounds\n      player {\n        databaseId\n        name\n        id\n      }\n      ...Player_tournamentPlayer\n      id\n    }\n    id\n  }\n}\n\nfragment StatusDropdown_flight on Flight {\n  id\n  status\n  tournamentRound {\n    status\n    id\n  }\n}\n\nfragment TournamentRoundMatchup_competitionMatchup on CompetitionMatchup {\n  databaseId\n  competitionPlayers {\n    databaseId\n    player {\n      category\n      databaseId\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment TournamentRound_tournamentRound on TournamentRound {\n  hideFlights\n  id\n  round\n  shotgun\n  useMarkerCodes\n  competitionMatchups {\n    databaseId\n    competitionPlayers {\n      player {\n        databaseId\n        id\n      }\n      id\n    }\n    id\n  }\n  courseLayout {\n    holesCount\n    id\n  }\n  flights {\n    databaseId\n    flightScores: activeFlightScores {\n      databaseId\n      pairId\n      playerId\n      id\n    }\n    ...Flights_flights\n    id\n  }\n  matchplays {\n    databaseId\n    matchplayPlayers {\n      databaseId\n      player {\n        databaseId\n        id\n      }\n      id\n    }\n    id\n  }\n  tournament {\n    databaseId\n    hasPairs\n    pairs(isActive: true) {\n      databaseId\n      id\n    }\n    teamplayConfiguration {\n      colorA\n      colorB\n      id\n    }\n    tournamentPlayers(isActive: true) {\n      rounds\n      player {\n        databaseId\n        name\n        id\n      }\n      id\n    }\n    id\n  }\n  ...EmailFlightInfo_tournamentRound\n  ...Pairs_tournamentRound\n  ...Players_tournamentRound\n}\n"
  }
};
})();

node.hash = "dc3d7966f22f64f44480d93c227bf431";

module.exports = node;
